import React from 'react';
import { Helmet } from 'react-helmet-async';

function SEO({
  title = 'AI 로또 번호 추천 - 인공지능 로또 예측 | 로또운세',
  description = 'AI 로또 번호 추천과 인공지능 로또 예측! GPT AI가 매일 분석하는 오늘의 행운의 숫자, 12별자리, 12띠, 타로 카드 운세를 무료로 확인하세요.',
  keywords = 'AI 로또 번호 추천, AI 추천 로또 번호, 인공지능 로또, AI 로또 예측, GPT 로또, 오늘 로또 번호 추천, 로또운세, 로또 운세, 오늘의 로또 번호, 오늘의 행운의 숫자, AI 운세, 인공지능 운세, 로또, 로또번호, 운세, 타로',
  url = 'https://lottounse.kr',
  image = 'https://lottounse.kr/og-image.png',
  type = 'website'
}) {
  const fullTitle = title.includes('로또운세') ? title : `${title} - 로또운세`;

  return (
    <Helmet>
      {/* 기본 메타 태그 */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="로또운세" />
      <meta property="og:locale" content="ko_KR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* 정규 URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
}

export default SEO;
